import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import Menu from '@groovehq/internal-design-system/lib/components/Dropdown/DropdownMenu'
import {
  divider,
  text,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { selectCurrentUser } from 'ducks/currentUser/selectors'
import GrooveStatusMenuItem from '../UserItem/GrooveStatusMenuItem'
import { styles } from './styles'

const openContactWidgetWithUserInfo = (user = {}) => {
  if (window?.groove?.widget) {
    window.groove.widget.updateSettings({
      iconPosition: 'left',
    })
    window.groove.widget.pushRoute('/contact')
    window.groove.widget.open()
    window.groove.widget.identifyContact('contact_email', user.email)
    window.groove.widget.setContact({
      contact_first_name: user.first_name,
      contact_last_name: user.last_name,
    })
  }
}

const HelpMenu = ({
  announcementCount,
  onClickAnnoucementsLauncher,
  onClickIdeasLauncher,
  showAnnoucementItem,
}) => {
  // We need to pass user details to Frill widgets
  // so need to make sure the user data exist
  const currentUser = useSelector(selectCurrentUser)

  const handleOpenContactWidget = useCallback(
    () => {
      openContactWidgetWithUserInfo(currentUser)
    },
    [currentUser]
  )

  const handleOpenKBWidget = useCallback(() => {
    if (window?.groove?.widget) {
      window.groove.widget.pushRoute('/kb')
      window.groove.widget.open()
    }
  }, [])

  return (
    <Menu as="div" css={styles.menu}>
      <Menu.Item
        itemKey="inbox-header"
        as="div"
        header
        css={text.styles.textSm}
      >
        Need a hand?
      </Menu.Item>
      {currentUser?.email &&
        showAnnoucementItem && (
          <Menu.Item
            as="div"
            itemKey="announcements"
            className="grui"
            onClick={onClickAnnoucementsLauncher}
          >
            <div>
              <span css={styles.emoji}>📣</span>
              &nbsp;&nbsp;Announcements
            </div>
            {announcementCount > 0 && (
              <span css={styles.badge}>{announcementCount}</span>
            )}
          </Menu.Item>
        )}
      <Menu.Item
        itemKey="kb"
        as="div"
        className="grui"
        onClick={handleOpenKBWidget}
      >
        <div>
          <span css={styles.emoji}>📚</span>
          &nbsp;&nbsp;View our Knowledge base
        </div>
      </Menu.Item>
      <Menu.Item
        as="div"
        itemKey="support"
        className="grui"
        onClick={handleOpenContactWidget}
      >
        <div>
          <span css={styles.emoji}>🚑</span>
          &nbsp;&nbsp;Contact support
        </div>
      </Menu.Item>
      {currentUser?.email && (
        <Menu.Item
          as="div"
          itemKey="request-feature"
          className="grui"
          onClick={onClickIdeasLauncher}
        >
          <div>
            <span css={styles.emoji}>💡</span>
            &nbsp;&nbsp;Request a feature
          </div>
        </Menu.Item>
      )}
      <Menu.Item
        as="div"
        itemKey="log-bug"
        className="grui"
        onClick={handleOpenContactWidget}
      >
        <div>
          <span css={styles.emoji}>🐞</span>
          &nbsp;&nbsp;Log a bug
        </div>
      </Menu.Item>
      <div css={divider.styles.primary} role="separator" />
      <GrooveStatusMenuItem iconHidden />
    </Menu>
  )
}

export default HelpMenu
